import { dataFetcher } from 'core/services/requestHandler';   

const getStudentList = async (data = {}, config = {}) => {
  return dataFetcher('users/getStudentList', data, {...config});
};

const activateStudent = async (data = {}, config = {}) => {
  return dataFetcher('users/activateStudent', data, {...config});
};

const deactivateStudent = async (data = {}, config = {}) => {
  return dataFetcher('users/deactivateStudent', data, {...config});
};

const updateStudentDetails = async (data = {}, config = {}) => {
  return dataFetcher('users/updateStudentDetails', data, {method: 'POST', ...config});
};

export { getStudentList, activateStudent, deactivateStudent, updateStudentDetails };
